import { prepareHttpHeaders } from "../utils/http";
import env from "../utils/env";

function getLocationParams(radius, { coords }) {
  return {
    SearchRadius: radius,
    "Address|Latitude": coords.latitude,
    "Address|Longitude": coords.longitude
  };
}

function getZipCodeParams(radius, { state, zipCode }) {
  return {
    Address: `,${state}`,
    "Address|ZipCode": zipCode,
    SearchRadius: radius
  };
}

function getCityParams(radius, { state, city }) {
  return { Address: `${city},${state}`, SearchRadius: radius };
}

function getSpecificParams(
  { zipRadius, cityRadius, locationRadius, searchBy, zipCode, city, state },
  location
) {
  if (location) {
    return getLocationParams(locationRadius, location);
  }
  if (searchBy === "Zip Code") {
    return getZipCodeParams(zipRadius, { state, zipCode });
  }
  return getCityParams(cityRadius, { state, city });
}

export function getPharmacySearch(
  {
    logged_in_member_id,
    save_pharmacy,
    health_category,
    dfdDashboard,
    ...rest
  },
  location
) {
  return {
    PharmacySearch: {
      ForConsult: true,
      Results: 100,
      ...getSpecificParams(rest, location)
    },
    logged_in_member_id,
    save_pharmacy,
    health_category,
    dfdDashboard
  };
}

function getSpecificDeliverabilityParams(
  { searchBy, zipCode, city, state },
  location
) {
  if (location) {
    return {
      latitude: location.coords.latitude,
      longitude: location.coords.longitude
    };
  }
  if (searchBy === "Zip Code") {
    return {
      zip_code: zipCode
    };
  }
  return {
    city,
    state
  };
}

function deliverabilityCheckParams({ logged_in_member_id, ...rest }, location) {
  return {
    PharmacySearch: {
      ...getSpecificDeliverabilityParams(rest, location)
    },
    logged_in_member_id
  };
}

export default function getPharmacies(config, resolveLocation = null) {
  return Promise.resolve(resolveLocation)
    .then(location =>
      fetch(`${env("BASE_URL")}/erx/pharmacy/search`, {
        method: "POST",
        headers: prepareHttpHeaders(),
        body: JSON.stringify(getPharmacySearch(config, location))
      })
    )
    .then(res => {
      return res.json();
    })
    .then(res => {
      if (res.error) {
        // eslint-disable-next-line no-throw-literal
        throw { name: "PharmacyAPIError", message: res.message || res.error };
      }
      return res;
    });
}

export async function capsuleDeliverabilityCheck(
  config,
  resolveLocation = null
) {
  return Promise.resolve(resolveLocation)
    .then(location =>
      fetch(`${env("BASE_URL")}/capsule/deliverability_check`, {
        method: "POST",
        headers: prepareHttpHeaders(),
        body: JSON.stringify(deliverabilityCheckParams(config, location))
      })
    )
    .then(res => {
      if (!res.ok) {
        return Promise.reject({
          name: "PharmacyAPIError",
          status: res.status
        });
      }

      return res.json();
    });
}
